<div style="font-size: 16px !important">
    <div nz-row class="pl-4 pr-4 mt-2">
        <div nz-col nzSpan="24" class="mt-1">
            <div nz-row>
                <div nz-col nzSpan="8" class="font-weight-600 pt-1 pb-2">
                    Consumer Name:
                </div>
                <div nz-col nzSpan="16" class="pt-2 pb-2"> {{claimDetails?.consumerName}} </div>
            </div>
        </div>

        <div nz-col nzSpan="24" class="mt-1">
            <div nz-row>
                <div nz-col nzSpan="8" class="font-weight-600 pt-1 pb-2">
                    Consumer PPL ID:
                </div>
                <div nz-col nzSpan="16" class="pt-2 pb-2"> {{claimDetails?.participantPplId}} </div>
            </div>
        </div>

        <div nz-col nzSpan="24" class="mt-1">
            <div nz-row>
                <div nz-col nzSpan="8" class="font-weight-600 pt-1 pb-2">
                    PPL ICN:
                </div>
                <div nz-col nzSpan="16" class="pt-2 pb-2">{{claimDetails?.pplIcn}} </div>
            </div>
        </div>

    </div>

    <form nz-form [formGroup]="adjustClaimForm" class="ppl-p0 form-container">
        @if(adjustType === 'service'){
        <!-- <div class="form-sec"> -->
        <div style="margin: 16px 16px 0 16px">
            <!-- <div nz-col nzSpan="24" class="mt-1">
                    <div nz-row>
                        <div nz-col nzSpan="8" class="font-weight-600 pt-1 pb-2">
                            Current Service Code:
                        </div>
                        <div nz-col nzSpan="16" class="pt-2 pb-2"> {{claimDetails?.serviceCodeDescription}}</div>
                    </div>
                </div> -->
            <div nz-col nzSpan="24" class="mt-1">
                <div nz-row>
                    <div nz-col nzSpan="8" class="font-weight-600 pt-1 pb-2">
                        New Service Code:
                    </div>
                    <div nz-col nzSpan="8" class="pt-2 pb-2">
                        <!-- @if(mode === 'edit'){ -->
                        <ppl-dropdown-select formControlName="serviceCodeDetailId" id="serviceCode"
                            placeholder="Service Code" [options]="serviceCodes"
                            [optionLabel]="'serviceCodeDesc'" [optionValue]="'serviceCodeId'">
                        </ppl-dropdown-select>
                        <!-- }
                            @else {
                                {{selectedServiceCode?.lkpValueName || '-' }}
                            } -->
                    </div>
                </div>
            </div>
        </div>
        <!-- </div> -->
        }
        @if(adjustType === 'mco'){
        <!-- <div class="form-sec"> -->
        <div style="margin: 16px 16px 0 16px">
            <!-- <div nz-col nzSpan="24" class="mt-1">
                    <div nz-row>
                        <div nz-col nzSpan="8" class="font-weight-600 pt-1 pb-2">
                            Current MCO:
                        </div>
                        <div nz-col nzSpan="16" class="pt-2 pb-2"> {{claimDetails?.mcoName}}</div>
                    </div>
                </div> -->
            <div nz-col nzSpan="24" class="mt-1">
                <div nz-row>
                    <div nz-col nzSpan="8" class="font-weight-600 pt-1 pb-2">
                        New MCO:
                    </div>
                    <div nz-col nzSpan="10" class="pt-2 pb-2">
                        <ppl-dropdown-select formControlName="mcoId" id="mcoId" placeholder="MCO" [options]="mcoEntries"
                            [optionLabel]="'orgName'" [optionValue]="'orgId'">
                        </ppl-dropdown-select>
                    </div>
                </div>
            </div>
            <div nz-col nzSpan="24" class="mt-1">
                <div nz-row>
                    <div nz-col nzSpan="8" class="font-weight-600 pt-1 pb-2">
                        New Auth:
                    </div>
                    <div nz-col nzSpan="10" class="pt-2 pb-2">
                        <ppl-dropdown-select formControlName="authId" id="authId" placeholder="Auth Number"
                            [options]="authList" [optionLabel]="'value'"
                            [optionValue]="'authId'">
                        </ppl-dropdown-select>
                    </div>
                </div>
            </div>
        </div>
        <!-- </div> -->
        }
        @if(showError){
            <p style="color: red; margin-left: 16px;"> {{errorMessage}} </p>
        }
        <div class="custom-row" style="width: 100%;">
            <ppl-button (click)="onAdjust()" style="margin-right: 8px;" label="Adjust" icon="fa fa-check-circle"
                [customClass]="'primary-button'" [iconPosition]="'right'"></ppl-button>
            <ppl-button (click)="onCancel()" style="margin-right: 8px;" label="Cancel" icon="fa fa-ban"
                [customClass]="'primary-button'" [iconPosition]="'right'"></ppl-button>
        </div>
    </form>

    @if(claimHistoryData?.length){
    <div class="ppl-container-head">
        <span>Adjustment History</span>
    </div>
    <div class="pl-4 pr-4 mt-2">
        <ppl-list-table [disableSearch]="true" [showCustomSearch]="false" [disableSelection]="true" [cols]="cols"
            [data]="claimHistoryData" (rowDetailEventTs)="rowActions($event)" [from]="'claimAdj'"></ppl-list-table>
    </div>
    }
</div>

<div class="filter-panel">
    <ng-template #claimTimesheetDetailsDialog let-cancel="cancel">
        <ppl-view-claim-timesheets [claimTSData]="claimTSData" [errorCode]="errorCode"></ppl-view-claim-timesheets>
    </ng-template>
</div>

<div class="filter-panel">
    <ng-template #adjustResultsDialog let-cancel="cancel">
        {{adjustResults}}
    </ng-template>
</div>